import React, { useState, useEffect } from 'react';

const CountdownInline = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const targetDate = new Date('2026-04-11T00:00:00+07:00');
      const difference = targetDate - new Date();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex gap-4 justify-center items-center text-center">
      <div>
        <div className="text-3xl font-bold text-sage">{timeLeft.days}</div>
        <div className="text-xs text-charcoal">DAYS</div>
      </div>
      <div className="text-2xl text-sage">:</div>
      <div>
        <div className="text-3xl font-bold text-sage">{timeLeft.hours}</div>
        <div className="text-xs text-charcoal">HOURS</div>
      </div>
      <div className="text-2xl text-sage">:</div>
      <div>
        <div className="text-3xl font-bold text-sage">{timeLeft.minutes}</div>
        <div className="text-xs text-charcoal">MINS</div>
      </div>
      <div className="text-2xl text-sage">:</div>
      <div>
        <div className="text-3xl font-bold text-sage">{timeLeft.seconds}</div>
        <div className="text-xs text-charcoal">SECS</div>
      </div>
    </div>
  );
};

export default CountdownInline;
